export const ORANGE_TRAIL_ELEMENTS_APPEARANCE = {
  theme: {
    appearance: "light",
    accentColor: "grass",
    grayColor: "sand",
    dangerColor: "red",
    warningColor: "orange",
    successColor: "grass",
    infoColor: "sky",
  },
  variables: {
    "--radius": "10px",
    "--color-background": "#fbf6ee",
    "--color-panel-solid": "#ffffff",
    "--color-panel-translucent": "#ffffff",
    "--color-stroke": "rgba(24, 24, 24, 0.10)",
    "--default-font-family": '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    "--heading-font-family": '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    "--strong-font-family": '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    "--default-letter-spacing": "-0.01em",
    "--heading-letter-spacing": "-0.035em",
    "--table-row-background-color": "transparent",
    "--accent-1": "#fbfdf8",
    "--accent-2": "#f3faef",
    "--accent-3": "#e6f5df",
    "--accent-4": "#d7efcc",
    "--accent-5": "#c5e7b6",
    "--accent-6": "#addb9b",
    "--accent-7": "#8dcc78",
    "--accent-8": "#64b84d",
    "--accent-9": "#349f20",
    "--accent-10": "#2a8c18",
    "--accent-11": "#287e1c",
    "--accent-12": "#143b0f",
    "--accent-9-contrast": "#ffffff",
    "--gray-1": "#ffffff",
    "--gray-2": "#fbfaf8",
    "--gray-3": "#f3f1ed",
    "--gray-4": "#eae7e1",
    "--gray-5": "#e1ddd5",
    "--gray-6": "#d6d0c7",
    "--gray-7": "#c6beb3",
    "--gray-8": "#aaa096",
    "--gray-9": "#7e756c",
    "--gray-10": "#71685f",
    "--gray-11": "#555160",
    "--gray-12": "#181818",
    "--orange-9": "#e88d3d",
    "--orange-10": "#d87c2e",
    "--orange-11": "#a9581d",
    "--orange-12": "#46250e",
    "--amber-1": "#fffdf9",
    "--amber-2": "#fbfaf8",
    "--amber-3": "#f3f1ed",
    "--amber-4": "#eae7e1",
    "--amber-5": "#e1ddd5",
    "--amber-6": "#d6d0c7",
    "--amber-7": "#c6beb3",
    "--amber-8": "#aaa096",
    "--amber-9": "#e88d3d",
    "--amber-10": "#d87c2e",
    "--amber-11": "#a9581d",
    "--amber-12": "#46250e",
    "--amber-a2": "rgba(24, 24, 24, 0.025)",
    "--amber-surface": "rgba(232, 141, 61, 0.055)",
    "--amber-9-contrast": "#181818",
    "--yellow-1": "#fffdf9",
    "--yellow-2": "#fbfaf8",
    "--yellow-3": "#f3f1ed",
    "--yellow-4": "#eae7e1",
    "--yellow-5": "#e1ddd5",
    "--yellow-6": "#d6d0c7",
    "--yellow-7": "#c6beb3",
    "--yellow-8": "#aaa096",
    "--yellow-9": "#e88d3d",
    "--yellow-10": "#d87c2e",
    "--yellow-11": "#a9581d",
    "--yellow-12": "#46250e",
    "--yellow-a2": "rgba(24, 24, 24, 0.025)",
    "--yellow-surface": "rgba(232, 141, 61, 0.055)",
    "--yellow-9-contrast": "#181818",
  },
  classes: {
    "whop-FieldLabel": { fontSize: "15px", fontWeight: "650" },
    "whop-FieldDescription": { fontSize: "13px", lineHeight: "1.5" },
    "whop-InputRoot": { minHeight: "48px", borderRadius: "10px" },
    "whop-Input": { padding: "12px 14px", fontSize: "15px" },
    "whop-SelectTrigger": { minHeight: "48px", padding: "10px 14px", borderRadius: "10px", fontSize: "15px" },
    "whop-SelectPopup": { borderRadius: "10px" },
    "whop-DialogContent": { borderRadius: "18px" },
    "whop-DialogHeader": { padding: "20px 22px" },
    "whop-DialogBody": { padding: "20px 22px" },
    "whop-DialogFooter": { padding: "16px 22px 20px" },
  },
};
